import React from "react";
import {Link} from "react-router-dom";

const NewsEventsCard = ({
  news,
  colClass = "col-lg-4 col-md-6 col-filter",
}) => {
  return (
    <div className={colClass} data-category={news.category}>
      <div  className="mrv-event-card text-decoration-none">
       {news?.date && (
         <div className="mrv-date-ribbon">{news.date}</div>
       )}

        <div className="mrv-card-img-wrap">
          <img src={news?.image} alt={news.title} loading="lazy" />
        </div>

        <div className="mrv-card-body">
          <span className="mrv-card-tag">{news.category}</span>

          <Link to={`/news-and-events/${news.id}`}  className="mrv-card-title text-decoration-none">{news.title}</Link>

          <p className="text-muted small news-desc">{news.description}</p>
          {news.location && (
              <span className="event-location">
                <i className={`bi ${news.icon2}`}></i> {news.location}
              </span>
            )}

          <div className="mrv-card-meta">
            {news.sport && (
              <span>
                <i className={`bi ${news.icon1}`}></i> {news.sport}
              </span>
            )}

            <Link to={`/news-and-events/${news.id}`}  className="mrv-guest-more">Read more &rarr;</Link>

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsEventsCard;
